import React, { Fragment, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import Menu from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownMenu'
import { divider } from '@groovehq/internal-design-system/lib/styles/elements'
import PresenceSettingsSidebar from '../SettingsSidebar'
import presenceTypes from '../presenceTypes'
import PresenceDropdownItem from './Item'
import PresenceDropdownSettingsItem from './SettingsItem'
import { styles } from './styles'

const PresenceDropdown = ({
  onPresenceChange,
  onSettingChange,
  autoAwaySetting,
  autoOfflineSetting,
  autoPresenceSetting,
  presence,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const handleOnPresenceChange = useCallback(
    newPresence => {
      if (newPresence === 'settings') {
        setIsSidebarOpen(!isSidebarOpen)
      } else if (onPresenceChange) {
        onPresenceChange(newPresence)
      }
    },
    [onPresenceChange, isSidebarOpen, setIsSidebarOpen]
  )

  const handleOnClose = useCallback(
    () => {
      setIsSidebarOpen(false)
    },
    [setIsSidebarOpen]
  )

  const handleOnSettingChange = useCallback(
    settings => {
      setIsSidebarOpen(false)
      if (onSettingChange) onSettingChange(settings)
    },
    [setIsSidebarOpen, onSettingChange]
  )

  const actualPresence = autoPresenceSetting ? 'autoPresence' : presence

  return (
    <Fragment>
      <Menu css={styles.overlayLg}>
        <>
          {Object.values(presenceTypes).map(({ id }) => {
            return (
              <PresenceDropdownItem
                key={id}
                itemKey={id}
                presence={id}
                highlight={actualPresence === id}
                onClick={handleOnPresenceChange}
              />
            )
          })}
          <div css={divider.styles.primary} role="separator" />
          <PresenceDropdownSettingsItem
            key="settings"
            itemKey="settings"
            presence="settings"
            onClick={handleOnPresenceChange}
          />
        </>
      </Menu>
      <PresenceSettingsSidebar
        open={isSidebarOpen}
        onClose={handleOnClose}
        onSave={handleOnSettingChange}
        autoAwaySetting={autoAwaySetting}
        autoOfflineSetting={autoOfflineSetting}
      />
    </Fragment>
  )
}

PresenceDropdown.propTypes = {
  /* onClick handler for an option (should trigger the presence change) */
  onPresenceChange: PropTypes.func,
}

PresenceDropdown.defaultProps = {
  // eslint-disable-next-line no-console
  onPresenceChange: console.log,
}

export default PresenceDropdown
